import { createAsyncThunk } from 'legacy/lut/store/utils/createAsyncThunk'

import { saveWelcomeFlowData as saveWelcomeFlowDataApi } from '../../api'

export const requestSaveUserData = createAsyncThunk(
  'welcomeFlow/requestSaveUserData',
  saveWelcomeFlowDataApi
)
